export enum CallBulletType {
    registered = 'REGISTERED',
    matched = 'MATCHED',
}
